import { SVGProps } from 'react';

export default function Delivery8(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      className="timeline-layout--svg--icon"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <g clipPath="url(#clip0_2317_3318)">
        <path
          d="M19.4048 8.38168C19.1705 8.10506 18.8786 7.88287 18.5496 7.7306C18.2206 7.57833 17.8623 7.49964 17.4998 7.50001H14.6498L11.094 1.28834C10.9058 0.936367 10.6329 0.636815 10.2999 0.41675C9.96695 0.196685 9.5844 0.0630408 9.18683 0.0278906C8.78926 -0.0072597 8.3892 0.0571916 8.02278 0.215422C7.65637 0.373652 7.33514 0.620676 7.08813 0.934177C6.88093 1.22298 6.74542 1.55696 6.69282 1.90849C6.64022 2.26003 6.67204 2.61904 6.78563 2.95584L8.4023 7.50001H4.6098L3.4298 5.91668C3.24543 5.63475 2.99363 5.40327 2.69723 5.24321C2.40082 5.08314 2.06916 4.99956 1.7323 5.00001C1.45376 4.99943 1.17921 5.06614 0.931997 5.19447C0.684784 5.3228 0.472232 5.50895 0.312424 5.73708C0.152617 5.96522 0.0502853 6.22858 0.0141363 6.50476C-0.0220127 6.78094 0.00909108 7.06177 0.104801 7.32334L1.66647 10L0.104801 12.6767C0.00918869 12.938 -0.0219497 13.2185 0.0140301 13.4944C0.0500099 13.7704 0.152045 14.0335 0.311471 14.2616C0.470897 14.4896 0.683004 14.6758 0.92978 14.8044C1.17656 14.933 1.45071 15.0001 1.72897 15C2.06583 15.0005 2.39749 14.9169 2.69389 14.7568C2.9903 14.5968 3.24209 14.3653 3.42647 14.0833L4.6098 12.5H8.4023L6.78563 17.0442C6.67204 17.381 6.64022 17.74 6.69282 18.0915C6.74542 18.4431 6.88093 18.777 7.08813 19.0658C7.33514 19.3793 7.65637 19.6264 8.02278 19.7846C8.3892 19.9428 8.78926 20.0073 9.18683 19.9721C9.5844 19.937 9.96695 19.8033 10.2999 19.5833C10.6329 19.3632 10.9058 19.0637 11.094 18.7117L14.6498 12.5H17.4998C17.9753 12.4962 18.4399 12.3573 18.8396 12.0996C19.2392 11.8419 19.5573 11.4759 19.757 11.0443C19.9566 10.6128 20.0295 10.1333 19.9671 9.66192C19.9048 9.19051 19.7098 8.74652 19.4048 8.38168Z"
          fill={props.fill || 'black'}
        />
      </g>
      <defs>
        <clipPath id="clip0_2317_3318">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
